import React from "react";
import { DateTime } from "luxon";

import { formatTimeLocalSmall } from "../Utilities";

import "./Calendar.css";
import "./DayTimeline.css";

interface IDayTimelineProps {
    entries: Array<{
        id?: string;
        name: string;
        runs: Array<{
            id: string;
            start: DateTime;
            end: DateTime;
            text?: string;
            color?: string;
        }>;
    }>;
}

interface IDayTimelineState {

}

class DayTimeline extends React.Component<IDayTimelineProps, IDayTimelineState> {
    constructor(props: Readonly<IDayTimelineProps>) {
        super(props);

        this.state = {

        };
    }

    public render() {
        return <div className="timeline-root">
            <div>
                <header>
                    <div className="timeline-label" />
                    <div>12 AM</div>
                    <div>1 AM</div>
                    <div>2 AM</div>
                    <div>3 AM</div>
                    <div>4 AM</div>
                    <div>5 AM</div>
                    <div>6 AM</div>
                    <div>7 AM</div>
                    <div>8 AM</div>
                    <div>9 AM</div>
                    <div>10 AM</div>
                    <div>11 AM</div>
                    <div>12 PM</div>
                    <div>1 PM</div>
                    <div>2 PM</div>
                    <div>3 PM</div>
                    <div>4 PM</div>
                    <div>5 PM</div>
                    <div>6 PM</div>
                    <div>7 PM</div>
                    <div>8 PM</div>
                    <div>9 PM</div>
                    <div>10 PM</div>
                    <div>11 PM</div>
                </header>
                {
                    this.props.entries && this.props.entries.map(a => (
                        <div key={a.id || a.name} className="timeline-row">
                            <div className="timeline-label">{a.name}</div>
                            <div>
                                {Array.from(Array(24)).map((a, i) => <div key={i} />)}
                                {a.runs.map(b => (
                                    <span key={b.id} style={{ left: `calc(4.16666% * ${this.startTime(b.start, b.end)})`, width: `calc(4.16666% * ${this.timeDiff(b.start, b.end)})` }} className={b.color ? `dt-${b.color}` : undefined}>{formatTimeLocalSmall(b.start)} - {formatTimeLocalSmall(b.end)}<br />{b.text}</span>
                                ))}
                            </div>
                        </div>))
                }
            </div>
        </div>;
    }

    private timeDiff(start: DateTime, end: DateTime) {
        const hoursDiff = (end.diff(start, "hours")).hours;
        const endOfDay = start.endOf("day");
        return hoursDiff === 0
            ? 24
            : end > endOfDay
                ? start.endOf("day").diff(start, "hours").hours
                : hoursDiff;
    }

    private startTime(start: DateTime, end: DateTime) {
        return start.hour + (start.minute / 60.0);
        /*return start < end.startOf("day")
            ? 0
            : start.hour + (start.minute / 60.0);
        */
    }
}

export default DayTimeline;
